import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import CloseButton from 'react-bootstrap/CloseButton';
import './Header.css';

const Header: React.FC = () => {
  const [open, setOpen] = useState(false);

  const onDisplayMenu = () => {
    setOpen(!open);
  };

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <div className="logo">
          <img src="/images/svecLogo.jpg" alt="Svec logo" />
        </div>

        {/* Mobile menu toggle button should have close icon when open */}
        <button 
          className={`menu-toggle ${open ? 'open' : ''}`}
          aria-label="Toggle navigation"
          onClick={() => onDisplayMenu()}
        >
          {open ? (
            <>
              <CloseButton aria-label="Close large" className='closeMenuBtn' />
            </>
          ) : (
            <>
              <span />
              <span />
              <span />
            </>
          )}
        </button>
        {/* <button
          className={`menu-toggle ${open ? 'open' : ''}`}
          aria-label="Toggle navigation"
          onClick={() => onDisplayMenu()}
        >
          <span />
          <span />
          <span />
        </button> */}

        <nav className={`nav ${open ? 'open' : 'nav-closed'}`}>
          <NavLink className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'} to="/" onClick={() => setOpen(false)}>Home</NavLink>
          <NavLink className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'} to="/about" onClick={() => setOpen(false)}>About Us</NavLink>
          <NavLink className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'} to="/services" onClick={() => setOpen(false)}>Our Services</NavLink>
          <NavLink className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'} to="/projects" onClick={() => setOpen(false)}>Projects</NavLink>
          <NavLink className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'} to="/contact" onClick={() => setOpen(false)}>Contact Us</NavLink>
        </nav>
      </div>
    </header>
  );
};

export default Header;
